import{a as e}from"./chunk-LD3Z6ZPJ.js";import{a as c}from"./chunk-XMIU4BRR.js";import{e as t}from"./chunk-5ILEFRK4.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-KIBW7NAJ.js.map
